import styled from 'styled-components';
import { PlayLinkContainer } from '../Link';
import PlayLinkExternal from '../Link/PlayLinkExternal';
import { ClearFix, PlayFocus } from '../../ui-components/utils.styles';
import { regularWhite, regularBlack } from '../../ui-components/design-tokens';
import { device, deviceGte } from '../../ui-components/breakpoints';
import { ButtonLink } from '../../ui-components/PlayButton/PlayButton.styles';
import { PlayContainer } from '../../ui-components/PlayContainer/PlayContainer.styles';
import { playFontSize } from '../../ui-components/typography/helpers';

export const FooterContainer = styled.footer`
    ${ClearFix}
    color: ${regularWhite};
    display: block;
    position: relative;
    margin-top: 10px;
    flex: 0 0 auto;
    background-color: ${regularBlack};
    z-index: 0;

    @media ${device.GteSmall} {
        margin-top: 20px;
    }

    @media ${device.GteLarge} {
        margin-top: 30px;
    }

    @media print {
        display: none !important;
    }

    .flexboxtweener {
        flex-shrink: 0;
    }
`;

export const IconContainer = styled.div`
    text-align: center;
    display: block;
`;

export const Buttons = styled.div`
    margin-top: 30px;
    text-align: center;

    .no-js & {
        display: none;
    }
`;

export const Button = styled(ButtonLink)`
    margin: 5px 10px;

    @media ${device.GteSmall} {
        display: inline-block;
        margin: 0 5px;
    }
`;

Button.displayName = 'FooterButton';

export const Services = styled.ul`
    list-style: none;
    padding: 0;
    width: 230px;
    margin: 30px auto 20px;

    @media ${device.GteSmall} {
        width: 400px;
    }
`;

export const Service = styled.li`
    display: inline-block;
    ${playFontSize(1.2)};

    &:nth-child(even) {
        float: right;

        @media ${device.GteSmall} {
            float: none;
        }
    }

    .app &.play_is-app-hidden {
        display: none;
    }

    @media ${device.GteSmall} {
        ${playFontSize(1.3)};
    }
`;

Service.displayName = 'Service';

export const ServiceLink = styled(PlayLinkExternal)`
    display: inline-block;
    padding: 10px;
`;

export const Genres = styled(PlayContainer)`
    padding: 15px 0;

    @media ${device.GteSmall} {
        padding: 25px 0;
    }

    @media ${device.GteMedium} {
        padding: 45px 0;
    }
`;

export const GenresList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    columns: 2 auto;

    @media ${deviceGte(450)} {
        columns: 4 auto;
    }
`;

export const GenresListElement = styled.li`
    margin-bottom: 15px;

    &:nth-child(4),
    &:nth-child(12) {
        padding-bottom: 15px;
    }

    @media ${device.GteMedium} {
        &:nth-child(4),
        &:nth-child(12) {
            padding-bottom: 15px;
        }
    }
`;

export const GenreLink = styled(PlayLinkContainer)`
    ${PlayFocus}
    color: ${regularWhite};
    text-decoration: none;
    &:hover,
    &:active,
    &:focus {
        text-decoration: underline;
    }
`;
